// TODO - Type 'any' needs to be fixed.
import AddIcon from "@mui/icons-material/Add";
import DateRangeIcon from "@mui/icons-material/DateRange";
import SendIcon from "@mui/icons-material/Send";
import { Button, Divider, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { startOfHour } from "date-fns";
import addHours from "date-fns/addHours";
import format from "date-fns/format";
import { useEffect, useState } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { FLEX_SCHEDULER_PERMISSIONS } from "../../../config/permissions";
import { useDateFnsLocale } from "../../../utils/date-locale";
import { hasPermissionString } from "../../../utils/helpers";
import { resetPublishDraftShiftsState } from "../store/scheduler-slice";
import {
	changeDayNoCache,
	changeWeeklyAvailability,
} from "../store/scheduler-slice";
import { changeWeekNoCache } from "../store/scheduler-slice";
import SwitchViews from "./switch-views";
import WeekNavigator from "./week-navigator";

interface ICalendarHeaderProps {
	checked: boolean;
	toggleScheduler: boolean;
	collapseFilter: () => void;
	type?: any;
	openCreateWeekShiftDialog: (date: any) => void;
	openCreateNewShiftDialog: (date: any) => void;
	openReviewPublishShiftDialog: (shiftIds: number[]) => void;
}

const CalendarHeader: React.FC<ICalendarHeaderProps> = ({
	checked,
	toggleScheduler,
	collapseFilter,
	type = null,
	openCreateWeekShiftDialog,
	openCreateNewShiftDialog,
	openReviewPublishShiftDialog,
}) => {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const dateLocale = useDateFnsLocale();

	const [currentMonth, setCurrentMonth] = useState("");
	const [isLoading, setIsLoading] = useState(true);
	const [enableCreateShift, setEnableCreateShift] = useState(false);
	const currentDate = useSelector(
		(state: any) => state.supervisor?.schedulerData?.currentDate
	);

	const isWeekView = useSelector((state: any) => state.supervisor?.weekView);
	const shiftBySkills = useSelector(
		(state: any) => state.user.userData.shiftBySkills
	);
	const fetchFilterAndShiftDataStatus = useSelector(
		(state: any) => state.supervisor?.fetchFilterAndShiftData?.status
	);
	const changeWeekAsyncStatus = useSelector(
		(state: any) => state.supervisor?.changeWeekNoCache?.status
	);
	const changeDayAsyncStatus = useSelector(
		(state: any) => state.supervisor?.changeDayNoCache?.status
	);
	const value = useSelector(
		(state: any) => state.supervisor?.schedulerData?.selectedAvailabilityValue
	);
	const permissions = useSelector(
		(state: any) => state.user.userData.permissions
	);

	const publishAndNotifyHandler = () => {
		dispatch(resetPublishDraftShiftsState());
		dispatch(openReviewPublishShiftDialog([]));
	};

	const handleForward = () => {
		if (isWeekView) {
			dispatch(changeWeekNoCache("forward"));
			if (type && value !== null) {
				dispatch(
					changeWeeklyAvailability({
						selection: "forward",
						shiftBySkills: shiftBySkills,
						type: type,
						id: value,
					})
				);
			}
			return;
		}
		dispatch(changeDayNoCache("forward"));
		// dispatch(changeDayAvailability("forward"));
	};

	const handleBack = () => {
		if (isWeekView) {
			dispatch(changeWeekNoCache("back"));
			if (type && value !== null) {
				dispatch(
					changeWeeklyAvailability({
						selection: "back",
						shiftBySkills: shiftBySkills,
						type: type,
						id: value,
					})
				);
			}
			return;
		}
		dispatch(changeDayNoCache("back"));
	};

	const handleToday = () => {
		dispatch(changeWeekNoCache("today"));
		if (type && value !== null) {
			dispatch(
				changeWeeklyAvailability({
					selection: "today",
					shiftBySkills: shiftBySkills,
					type: type,
					id: value,
				})
			);
		}
	};

	const handleCalendarClick = (e: any) => {
		if (isWeekView) {
			dispatch(changeWeekNoCache(new Date(e)));
			if (type && value !== null) {
				dispatch(
					changeWeeklyAvailability({
						selection: new Date(e),
						shiftBySkills: shiftBySkills,
						type: type,
						id: value,
					})
				);
			}
		} else {
			dispatch(changeDayNoCache(new Date(e)));
		}
	};

	useEffect(() => {
		setIsLoading(true);
		if (currentDate) {
			const dt = format(new Date(currentDate), "MMM yyyy", {
				locale: dateLocale,
			});
			setCurrentMonth(dt.toString());
			setIsLoading(false);
		}
	}, [currentDate, dateLocale]);

	useEffect(() => {
		if (changeWeekAsyncStatus === "pending" || changeDayAsyncStatus === "pending") {
			setEnableCreateShift(false);
		} else if (fetchFilterAndShiftDataStatus === "fulfilled") {
			setEnableCreateShift(true);
		}
	}, [fetchFilterAndShiftDataStatus, changeWeekAsyncStatus, changeDayAsyncStatus]);

	return (
    <Box
      sx={{
        height: "56.5px",
        minWidth: "1364px",
        padding: "12px 24px 12px 12px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginLeft: "4px",
      }}
    >
      <Box display="flex" alignItems="center">
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              flexDirection: "row",
            }}
          >
            <Skeleton
              variant="rounded"
              width={64}
              height={32}
              sx={{
                borderRadius: "4px",
                marginLeft: "8px",
              }}
            />
            <Skeleton
              variant="rounded"
              width={32}
              height={32}
              sx={{
                marginLeft: "24px",
                borderRadius: "4px",
              }}
            />
            <Skeleton
              variant="rounded"
              width={192}
              height={32}
              sx={{
                borderRadius: "4px",
                marginLeft: "24px",
              }}
            />
            <Skeleton
              variant="rounded"
              width={32}
              height={32}
              sx={{
                borderRadius: "4px",
                marginLeft: "24px",
              }}
            />
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {toggleScheduler && (
                <Button
                  variant="outlined"
                  onClick={handleToday}
                  sx={{
                    height: "36px",
                    border: "1px solid rgba(0,0,0,0.08)",
                    borderColor: "rgba(0,0,0,0.08) !important",
                    color: "rgba(0,0,0,0.6)",
                    marginLeft: "8px",
                  }}
                >
                  {t("scheduler_today")}
                </Button>
              )}
              {!toggleScheduler && (
                <Button
                  variant="outlined"
                  onClick={handleToday}
                  sx={{
                    height: "36px",
                    border: "1px solid rgba(0,0,0,0.08)",
                    borderColor: "rgba(0,0,0,0.08) !important",
                    color: "rgba(0,0,0,0.6)",
                    marginLeft: "8px",
                  }}
                >
                  {t("scheduler_today")}
                </Button>
              )}
            </Box>
            <WeekNavigator
              handleBack={handleBack}
              handleForward={handleForward}
              handleCalendarClick={handleCalendarClick}
              date={currentDate}
              isWeekView={isWeekView}
            />
          </Box>
        )}
      </Box>
      {isLoading ? (
        <Skeleton
          variant="rounded"
          width={85}
          height={32}
          sx={{
            borderRadius: "4px",
            marginRight: "16px",
            marginLeft: "16px",
          }}
        />
      ) : (
        <Typography
          sx={{
            fontFamily: "Roboto",
            fontSize: "20px",
            fontWeight: 400,
            color: "#000000",
            lineHeight: "28px",
            marginRight: "16px",
            marginLeft: "16px",
            minWidth: "85px",
          }}
        >
          {currentMonth}
        </Typography>
      )}
      {!toggleScheduler && (
        <Box sx={{ marginLeft: "8px", marginRight: "8px" }}>
          {isLoading ? (
            <Skeleton
              variant="rounded"
              width={200}
              height={36}
              sx={{
                borderRadius: "4px",
              }}
            />
          ) : (
            <SwitchViews isWeekView={isWeekView} />
          )}
        </Box>
      )}
      {!toggleScheduler ? (
        <Box display="flex" alignItems="center">
          <Divider
            orientation="vertical"
            flexItem
            sx={{ marginRight: "8px", height: "28px", alignSelf: "center" }}
          />
          {hasPermissionString(
            permissions,
            FLEX_SCHEDULER_PERMISSIONS.COPY_SHIFT
          ) &&
            (!enableCreateShift ? (
              <Skeleton
                variant="rounded"
                width={130}
                height={32}
                sx={{
                  borderRadius: "4px",
                  marginLeft: "8px",
                }}
              />
            ) : (
              <Button
                variant="text"
                startIcon={<DateRangeIcon />}
                onClick={() => openCreateWeekShiftDialog(new Date(currentDate))}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  flexWrap: "nowrap",
                  height: "36px",
                  marginRight: "8px",
                  marginLeft: "8px",
                  lineHeight: "18px",
                  minWidth: "130px",
                }}
                color="primary"
              >
                {t("scheduler_copy-shifts")}
              </Button>
            ))}
          {hasPermissionString(
            permissions,
            FLEX_SCHEDULER_PERMISSIONS.CREATE_SHIFT
          ) &&
            (!enableCreateShift ? (
              <Skeleton
                variant="rounded"
                width={110}
                height={32}
                sx={{
                  borderRadius: "4px",
                  marginLeft: "8px",
                }}
              />
            ) : (
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={() =>
                  openCreateNewShiftDialog(
                    addHours(startOfHour(addHours(new Date(), 1)), 24)
                  )
                }
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  flexWrap: "nowrap",
                  height: "36px",
                  marginRight: "8px",
                  marginLeft: "8px",
                  lineHeight: "18px",
                  minWidth: "110px",
                }}
                color="primary"
              >
                {t("scheduler_shift")}
              </Button>
            ))}
          {hasPermissionString(
            permissions,
            FLEX_SCHEDULER_PERMISSIONS.PUBLISH_SHIFT
          ) &&
            (!enableCreateShift ? (
              <Skeleton
                variant="rounded"
                width={210}
                height={32}
                sx={{
                  borderRadius: "4px",
                  marginLeft: "8px",
                }}
              />
            ) : (
              <Button
                variant="contained"
                startIcon={<SendIcon />}
                onClick={() => publishAndNotifyHandler()}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  flexWrap: "nowrap",
                  height: "36px",
                  marginLeft: "8px",
                  lineHeight: "18px",
                  minWidth: "210px",
                }}
                color="primary"
              >
                {t("scheduler_publish-and-notify")}
              </Button>
            ))}
        </Box>
      ) : (
        <Box
          sx={{
            width: "500px", // To align header at center
          }}
        />
      )}
    </Box>
  );
};

export default CalendarHeader;
